/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceGroupDto } from '../models/DeviceGroupDto';
import type { EntityModelResponseContainerDeviceGroupDto } from '../models/EntityModelResponseContainerDeviceGroupDto';
import type { PagedModelEntityModelDeviceGroupDto } from '../models/PagedModelEntityModelDeviceGroupDto';
import type { PagedResourcesAssemblerDeviceGroupDto } from '../models/PagedResourcesAssemblerDeviceGroupDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeviceGroupControllerService {
    /**
     * @returns PagedModelEntityModelDeviceGroupDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        name,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerDeviceGroupDto,
        name?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceGroupDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/device-groups',
            query: {
                'name': name,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceGroupDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
        xDeleteProperties,
    }: {
        requestBody: DeviceGroupDto,
        xDeleteProperties?: Array<'NETWORK_POLICY_ID' | 'NAME' | 'DESCRIPTION'>,
    }): CancelablePromise<EntityModelResponseContainerDeviceGroupDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/device-groups',
            headers: {
                'X-DELETE-PROPERTIES': xDeleteProperties,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        deviceGroupId,
    }: {
        deviceGroupId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/device-groups/{deviceGroupId}',
            path: {
                'deviceGroupId': deviceGroupId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceGroupDto OK
     * @throws ApiError
     */
    public static read({
        deviceGroupId,
    }: {
        deviceGroupId: number,
    }): CancelablePromise<EntityModelResponseContainerDeviceGroupDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/device-groups/{deviceGroupId}',
            path: {
                'deviceGroupId': deviceGroupId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceGroupDto OK
     * @throws ApiError
     */
    public static update({
        deviceGroupId,
        requestBody,
        xDeleteProperties,
    }: {
        deviceGroupId: number,
        requestBody: DeviceGroupDto,
        xDeleteProperties?: Array<'NETWORK_POLICY_ID' | 'NAME' | 'DESCRIPTION'>,
    }): CancelablePromise<EntityModelResponseContainerDeviceGroupDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/device-groups/{deviceGroupId}',
            path: {
                'deviceGroupId': deviceGroupId,
            },
            headers: {
                'X-DELETE-PROPERTIES': xDeleteProperties,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
